import { render, staticRenderFns } from "./SysMem.vue?vue&type=template&id=33f4a85e"
import script from "./SysMem.vue?vue&type=script&lang=js"
export * from "./SysMem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports